import React from 'react';

import { AppsProps } from '@/pages/apps';
import { UserType } from '@/services/appsSMS';

import AppInfo from '../static-pages/apps/AppInfo';
import AppsForm from '../static-pages/apps/AppsForm';

export interface IBlock<T> {
  type: string;
  value: T;
}

export interface ImageProps {
  title: string;
  url: string;
}

const AppsTemplate: React.FC<AppsProps> = ({ contentBlocks = [] }) => {
  //format and filter data from wagtail
  const appsFormData =
    contentBlocks[0] && contentBlocks[0].type === 'split' ? contentBlocks[0].value : null;

  const renterAppInfo =
    contentBlocks[1] &&
    contentBlocks[1].type === 'split' &&
    contentBlocks[2] &&
    contentBlocks[2].type === 'content-grid'
      ? { split: contentBlocks[1].value, list: contentBlocks[2].value }
      : null;

  const ownerAppInfo =
    contentBlocks[3] &&
    contentBlocks[3].type === 'split' &&
    contentBlocks[4] &&
    contentBlocks[4].type === 'content-grid'
      ? { split: contentBlocks[3].value, list: contentBlocks[4].value }
      : null;

  return (
    <main>
      {appsFormData && <AppsForm left={appsFormData.left} right={appsFormData.right} />}
      {renterAppInfo && (
        <AppInfo split={renterAppInfo.split} list={renterAppInfo.list} appType={UserType.renter} />
      )}
      {ownerAppInfo && (
        <AppInfo split={ownerAppInfo.split} list={ownerAppInfo.list} appType={UserType.owner} />
      )}
    </main>
  );
};

export default AppsTemplate;
